var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AptiveIcon } from '@aptive-env/storybook';
import { useEffect, useRef, useState, useMemo } from 'react';
import ImageCheckboxChecked from 'assets/image/checkbox-checked.png';
import ImageCheckboxUnchecked from 'assets/image/checkbox-unchecked.png';
var MultiEventSelect = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange;
    var ref = useRef(null);
    var _b = useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var handleSelect = function (item) {
        if (!value.includes(item))
            onChange(__spreadArray(__spreadArray([], value, true), [item], false));
        if (value.includes(item))
            onChange(value.filter(function (type) { return type !== item; }));
    };
    var isAllOptionsSelected = useMemo(function () {
        return options.length === value.length;
    }, [options, value]);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (event.target instanceof HTMLElement && ref.current && !ref.current.contains(event.target)) {
                event.stopPropagation();
                setIsExpanded(false);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    var handleClickSelectAll = function () {
        if (!isAllOptionsSelected) {
            onChange(options);
        }
        else {
            onChange([]);
        }
    };
    return (_jsx("div", __assign({ className: "bg-white border border-[#E5E7EB] rounded-md h-[38px] px-2 py-2" }, { children: _jsxs("div", __assign({ className: "relative" }, { children: [_jsxs("div", __assign({ className: "flex items-center justify-between cursor-pointer", onClick: function () { return setIsExpanded(function (prev) { return !prev; }); } }, { children: [_jsx("div", __assign({ className: "mx-1 text-[14px] text-[#4B5563]" }, { children: "Events" })), _jsx(AptiveIcon, { className: "w-[20px] h-[20px] stroke-aro-gray fill-none", icon: isExpanded ? 'chevronUp' : 'chevronDown' })] })), isExpanded && (_jsxs("div", __assign({ ref: ref, className: "shadow rounded-lg overflow-hidden absolute z-[100] bg-white w-[200px] -ml-2 mt-3" }, { children: [_jsxs("div", __assign({ className: "item flex items-center h-9 px-3 cursor-pointer border-b hover:bg-ui-gray-100 ", onClick: handleClickSelectAll }, { children: [_jsx("div", { children: isAllOptionsSelected ? (_jsxs("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("rect", { width: "16", height: "16", rx: "4", fill: "white" }), _jsx("rect", { x: "0.5", y: "0.5", width: "15", height: "15", rx: "3.5", fill: "#007AFF", stroke: "#007AFF" }), _jsx("path", { d: "M3 7.5C3 7.22386 3.22386 7 3.5 7H12.5C12.7761 7 13 7.22386 13 7.5V8.5C13 8.77614 12.7761 9 12.5 9H3.5C3.22386 9 3 8.77614 3 8.5V7.5Z", fill: "white" })] }))) : (_jsx("img", { src: ImageCheckboxUnchecked, alt: "ImageCheckboxUnchecked" })) }), _jsx("div", __assign({ className: "text-ui-gray-600 text-[14px] ml-2" }, { children: "Select all" }))] })), options.map(function (item, index) { return (_jsxs("div", __assign({ className: "h-9 flex items-center whitespace-nowrap px-3 cursor-pointer border-b hover:bg-ui-gray-100", onClick: function () { return handleSelect(item); } }, { children: [_jsx("div", { children: value.includes(item) ? (_jsx("img", { src: ImageCheckboxChecked, alt: "ImageCheckboxChecked" })) : (_jsx("img", { src: ImageCheckboxUnchecked, alt: "ImageCheckboxUnchecked" })) }), _jsx("div", __assign({ className: "ml-2 text-[14px] text-[#4B5563]" }, { children: item.name }))] }), index)); })] })))] })) })));
};
export default MultiEventSelect;
